// Lib
import React from 'react';
import CloseIcon from '@mui/icons-material/Close';

import { useStyles } from './CloseButtonStyles';

const CloseButton = ({ onClose, className, ...props }) => {
  const { classes, cx } = useStyles();

  return (
    <CloseIcon
      {...props}
      onClick={onClose}
      className={cx(classes.closeIcon, className)}
    />
  );
};

export default CloseButton;
